/**
 * Normalize legacy / mixed API task rows to the shape NewTaskGrid expects.
 * Safe to call on already-normalized rows (idempotent for taskId).
 */
export const normalizeTaskGridRow = (task) => {
  if (!task || typeof task !== "object") {
    return task;
  }

  const taskId = task.taskId ?? task.id ?? task.TaskId ?? null;

  return {
    ...task,
    taskId,
    title: task.title ?? task.description ?? task.projectTaskTitle ?? "",
    estimateHours:
      task.estimateHours ?? task.estTime ?? task.EstimateHours ?? null,
    remainingHours:
      task.remainingHours ?? task.remTime ?? task.RemainingHours ?? null,
    remTime: task.remTime ?? task.remainingHours ?? task.RemainingHours ?? null,
    deadLine: task.deadLine ?? task.deadline ?? task.DeadLine ?? null,
    taskStatusId:
      task.taskStatusId ?? task.TaskStatusId ?? task.projectStatusConfigurationId ?? null,
    statusName: task.statusName ?? task.status ?? task.StatusName ?? null,
    statusCategoryName:
      task.statusCategoryName ?? task.StatusCategoryName ?? null,
    priorityId: task.priorityId ?? task.PriorityId ?? null,
    priorityName: task.priorityName ?? task.priority ?? task.PriorityName ?? null,
    taskTypeId: task.taskTypeId ?? task.TaskTypeId ?? null,
    taskTypeName: task.taskTypeName ?? task.TaskTypeName ?? null,
    assignedTo: task.assignedTo ?? task.userId ?? task.AssignedTo ?? null,
    assigneeName:
      task.assigneeName ??
      task.assignee ??
      task.AssigneeName ??
      task.assignedToName ??
      task.AssignedToName ??
      null,
    actualHours: task.actualHours ?? task.ActualHours ?? null,
  };
};

export const normalizeTaskGridRows = (list) => {
  if (!Array.isArray(list)) {
    return [];
  }
  return list.map(normalizeTaskGridRow);
};

export default normalizeTaskGridRow;
